import * as React from 'react';
import SVGInline from 'react-svg-inline';
import * as classnames from 'classnames/bind';

import styles from './Card.scss';
import bubbleTip from './bubble-tip-logo.svg';

const cx = classnames.bind(styles);

export interface CardProps {
  bubble?: 'left' | 'right';
  className?: string;
}

const Card: React.SFC<CardProps> = ({ children, bubble, className = '' }) => (
  <div className={`${styles.card} ${className}`}>
    {bubble && (
      <>
        <SVGInline svg={bubbleTip} className={cx('bubbleTip', bubble)} />
        <SVGInline svg={bubbleTip} className={cx('bubbleTip', 'shadow', bubble)} />
      </>
    )}
    {children}
  </div>
);

export default Card;



// WEBPACK FOOTER //
// /www/client/src/components/Card/Card.tsx